import React from 'react';
import { compose, withHandlers, lifecycle } from 'recompose';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import CardStatus from '../CardStatus';

import { COLORS, commonStyles } from '../../styles/styles';
import iconThinkTool from '../../assets/icon_thinktool_b.png';

import mail from '../../assets/closeEnvelope.svg';
import videoContent from '../../assets/icon_Video_W.svg';
import journalContent from '../../assets/icon_Journal_W.svg';

import pdfContent from '../../assets/icon_PDF_W.svg';
import surveyContent from '../../assets/icon_Survey_W.svg';
import surveyContent2 from '../../assets/icon_Survey2_W.svg';
import html from '../../assets/icon_HTML_W.svg';
import thinktoolContent from '../../assets/icon_thinktool_W.svg';
import check from '../../assets/check.svg';

import {showMessageCenter} from '../../redux/reducers/messagesList'
import { getUserProgramsFullRequest, selectUserPrograms, selectUser, selectUserThinkTool, selectRollout } from '../../redux/reducers/userProgramsFull';
import { selectedThinkTool, getSelectedThinktool, getAllThinkToolsAndJournals, selectedProgram } from '../../redux/selectors';
import { withRouter } from 'react-router-dom';

import {
  MDBBtn, MDBCard, MDBCardBody, MDBCardImage, MDBCardTitle, MDBCardText, MDBRow, MDBCol, MDBIcon, MDBBadge, MDBContainer 
} from "mdbreact";
import authHOC from '../AuthHOC';
import { STORAGE_LINK } from '../../constants';

export const getCardTitle = type => {
  switch (type) {
    case 'ThinkTool':
      return thinktoolContent;
    case 'Document':
      return pdfContent;
    case 'Video':
      return videoContent;
    case 'Journal':
      return journalContent;
    case 'Survey':
        return surveyContent2;
    case 'HTML Captivate':
        return html;
    case 'HTML Articlulate':
        return html;
    default:
      return surveyContent;
  }
};

export const getCardText = type => {
  switch (type) {
    case 'ThinkTool':
      return 'ThinkTool';
    case 'Document':
      return 'Document';
    case 'Video':
      return 'Video';
    case 'Journal':
      return 'Activity';
    case 'Survey':
      return 'Survey';
    case 'HTML Captivate':
      return 'HTML';
    case 'HTML Articlulate':
      return 'HTML';
    default:
      return 'Survey';
  }
};


export const getCardIcon = type => {
  switch (type) {
    case 'ThinkTool':
      return 'brain';
    case 'Document':
      return 'file-pdf';
    case 'Video':
      return 'video';
    case 'Journal':
      return 'pencil-ruler';
    case 'Survey':
      return 'list-ul';
    case 'Assessment':
        return 'vial';
    case 'HTML Captivate':
      return 'code';
    case 'HTML Articlulate':
      return 'code';
    default:
      return 'list-ul';
  }
};

const ThinkToolCard = ({
  selectedThinktool,
returnFromThinktoolCard
}) => (
  <MDBCard className='z-depth-2 mb-2 d-none d-md-block'>
    {}
        <div style={{position:'relative', paddingBottom:10}}>
          <div className="compImg">
            <img src={STORAGE_LINK+selectedThinktool.backgroundImg}  className="z-depth-0 rounded-corners" style={{padding: 10, width:'100%'}} alt="" />
          </div>
          
          
          {/* <div  style={{position:'absolute', bottom:10, zIndex:2}}>
            <div className='xs-copy text-white uppercase-text text-left pt-3 pl-3'>
              {getCardText(selectedThinktool.type)}
            </div>
            <h6 className='text-white text-left pl-3 pb-2'>
              {selectedThinktool.name}
            </h6>
          </div>
          <img src={process.env.REACT_APP_MY_VAR+selectedThinktool.backgroundImg} className="z-depth-0" style={{padding: 0, height: '100%', width: '100%'}} alt="" />
          <div style={{padding: 0, height: '100%', width: '100%', position:'absolute', bottom:0, left:0}} className='background-gradient-main2'></div> */}
        </div>
        {/* <div style={{position:'absolute', right:10, top:10}}>
    
        </div> */}
        <MDBBtn
          floating
          left
          tag='a'
          size='sm'
          className='ml-auto ml-4 '
          action
          style={{position: 'absolute', left: -30, top:30}} 
          onClick={()=>returnFromThinktoolCard()}
        >
          <MDBIcon icon='angle-left' className="secondary-color" size="sm"/>
      </MDBBtn>

    <MDBCardBody  style={{position:'relative'}}>
          <div className="compIcon" style={{top:-42}}>
              <img src={iconThinkTool} />
          </div>
          <h6>
            {selectedThinktool.name}
          </h6>
          <div className="copy">
            {selectedThinktool.description}
          </div>
        </MDBCardBody>
        {/* <MDBCardBody >
          <div className='text-black-50 text-left pt-3'>
            {selectedThinktool.description}
          </div>
        </MDBCardBody> */}
      </MDBCard>
  
);

ThinkToolCard.propTypes = {
  classes: PropTypes.instanceOf(Object),
  isSelected: PropTypes.bool,
  isTransparent: PropTypes.bool,
  backgroundImg: PropTypes.string,
  type: PropTypes.string,
  messageCount: PropTypes.number,
  name: PropTypes.string,
  dueDate: PropTypes.string,
  startDate: PropTypes.string,
  description: PropTypes.string,
  status: PropTypes.string,
  contentId: PropTypes.number,
  onThinkToolClick: PropTypes.func,
};

const styles = () => ({
  ...commonStyles,
  card: {
    borderRadius: 0,
    justifyContent: 'space-between',
    width: 200,
    height: 280,
    backgroundSize: 'cover',
    margin: '5px 5px 10px 5px',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'visible',
    cursor: 'pointer',
    backgroundColor: COLORS.white,
    opacity: 1,
  },
  isTransparent: {
    opacity: 0.4,
  },
  selectedCard: {
    borderColor: COLORS.cornerstoneRed,
  },
  cardContent: {
    padding: 0,
    height: '100%',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  cardContentWrapper: {
    padding: 20,
    display: 'flex',
    flex: 2,
    flexDirection: 'column',
  },
  fileWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: '15px 15px 30px 15px',
    backgroundColor: '#161616',
    flex: 1,
    backgroundSize: '100%'
  },
  cardIcon:{
    position: 'absolute',
    bottom: 15,
    right: 15,
    height: 50
  },
  cardTitle: {
    fontFamily: 'Gotham-Black',
    color: COLORS.darkGrey,
    fontSize: 16,
    lineHeight: '20px',
    marginBottom: 10,
  },
  itemLeft: {
    flex: 4,
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    position: 'relative',
    marginTop: 28,
    '&:focus': {
      outline: 'none',
    },
  },
  moduleDescription: {
    color: COLORS.darkGrey,
    fontSize: 10,
    lineHeight: '14px',
    fontWeight: 400,
    marginBottom: 10,
    maxHeight: 30,
    overflow: 'hidden',
  },
  cardBottom: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  doneWrapper: {
    position: 'absolute',
    top: 10,
    right: 10,
  },
  checkboxChecked: {
    display: 'block',
    width: 28,
    height: 28,
    borderRadius: '50%',
    background: `url(${check}) 0 no-repeat`,
  },
});

const mapStateToProps = state => ({
  loginReducer: state.loginReducer,
  programs: state.userProgramsFullReducer,
  selectedThinktool: getSelectedThinktool(state),
});

const mapDispatchToProps = dispatch => ({
  showMessageCenter: bool => dispatch(showMessageCenter(bool)),
  selectUserPrograms: programId => dispatch(selectUserPrograms(programId)),
  selectUser: userId => dispatch(selectUser(userId)),
  selectRollout: userId => dispatch(selectRollout(userId)),
  selectUserThinkTool: contentId => dispatch(selectUserThinkTool(contentId)),
  
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    returnFromThinktoolCard: props => () => {
      
      props.history.push(
        `/users/${props.programs.selectedProjectId}/${props.programs.selectedRollout}/${props.programs.selectedUserId}`+ props.history.location.search,
      );
    },
  }),
  lifecycle({
    componentWillMount(){
      console.log('TTX', this.props.selectedThinktool)
      if(this.props.match.params.projectId){
        this.props.selectUserPrograms(parseInt(this.props.match.params.projectId))
      }
      if(this.props.match.params.rolloutId){
        
        this.props.selectRollout(parseInt(this.props.match.params.rolloutId))
      }
      if(this.props.match.params.userId){
        
        this.props.selectUser(parseInt(this.props.match.params.userId))
      }
      if(this.props.match.params.thinktoolid){
        
        this.props.selectUserThinkTool(parseInt(this.props.match.params.thinktoolid))
      }
    },
    componentWillReceiveProps(nextProps){
      console.log('TTX', this.props.selectedThinktool)
    }
  }),
  withStyles(styles),
)(ThinkToolCard);



// WEBPACK FOOTER //
// ./src/Components/Cards/ThinkToolCard.jsx